const moment = require('moment');
import {restService} from'../rest.js';

const restServiceInstance = new restService();
function ocupacionEnTiempo() {
  this.millisFechaIni = 0;
  this.millisFechaFin = 0;
  this.reporteOcupacionTiempo = [];
  this.remisiones = [];
  this.remisionesPorProducto = {};
  this.getReporteOcupacion = function (axios, fechaIni, fechaFin) {
    this.millisFechaIni = moment(fechaIni).valueOf();
    this.millisFechaFin = moment(fechaFin).valueOf();
    const ocupacionTiempo = this;

    const promise = new Promise(((resolve, reject) => {
      restServiceInstance.getVehicles((vehicles) => {
        restServiceInstance.getTmsWayBill().then((tmswaybill) => {
          ocupacionTiempo.remisiones = tmswaybill;
          restService.getTmsWayBillProducts().then((tmsWayBillProducts) => {
            ocupacionTiempo.buildRemisionesHashMap(tmswaybill);
            let testCount = 0;
            console.log(vehicles);
            vehicles.forEach((unit) => {
              if (testCount < 3000 && unit.acquisition_date) {
                testCount++;
                const reporteOcupacionProducto = ocupacionTiempo.getOcupacionTiempoProducto(unit);
                let dateIni = moment(unit.acquisition_date).valueOf();
                if (ocupacionTiempo.millisFechaIni > dateIni) { dateIni = ocupacionTiempo.millisFechaIni; }
                const unitOcupacionEnTiempo = moment
                  .duration(
                    reporteOcupacionProducto.ocupacionTotalMillis,
                    'milliseconds',
                  )
                  .asDays()
                  .toFixed(2);

                const unitInventarioEnTiempo = moment
                  .duration(moment().valueOf() - dateIni, 'milliseconds')
                  .asDays()
                  .toFixed(2);
                if (parseFloat(unitInventarioEnTiempo) > 30) {
                  console.log(
                    ocupacionTiempo.millisFechaIni,
                    unit.acquisition_date,
                    dateIni,
                    'fecha adquisicion',
                  );
                }
                let marca = '';
                if (unit.model_id && unit.model_id[1].split('/').length > 0) { marca = unit.model_id[1].split('/')[0]; }
                ocupacionTiempo.reporteOcupacionTiempo.push({
                  ocupacionTiempo: unitOcupacionEnTiempo,
                  modelo: unit.model_id[1],
                  marca,
                  serie: unit.name,
                  detalle: reporteOcupacionProducto,
                  familia: unit.product_id[1],
                  inventarioTiempo: unitInventarioEnTiempo,
                  porcentajeOcupacion: (
                    unitOcupacionEnTiempo / unitInventarioEnTiempo
                  ).toFixed(2),
                });
              }
            });
            resolve(ocupacionTiempo.reporteOcupacionTiempo);
          });
          axios.get('tmswaybillproducts?fields=all').then((res) => {

          });
        })
          .catch((error) => {
            reject(error);
          });
      });
    }));
    return promise;
  };
  this.buildRemisionesHashMap = function (operacionesRemision) {
    const operacionesRemisionHashMap = {};
    operacionesRemision.forEach((operacion) => {
      operacionesRemisionHashMap[operacion.id] = operacion;
    });
    this.remisiones.forEach((remision) => {
      if (remision.waybill_shipped_product) {
        for (let i = 0; i < remision.waybill_shipped_product.length; i++) {
          if (
            !this.remisionesPorProducto[
              operacionesRemisionHashMap[remision.waybill_shipped_product[i]]
                .product_serie_id[0]
            ]
          ) {
            this.remisionesPorProducto[
              operacionesRemisionHashMap[
                remision.waybill_shipped_product[i]
              ].product_serie_id[0]
            ] = [];
          }
          this.remisionesPorProducto[
            operacionesRemisionHashMap[remision.waybill_shipped_product[i]]
              .product_serie_id[0]
          ].push(remision);
        }
      }
    });
  };

  this.getOcupacionTiempoProducto = function (producto) {
    let ocupacionTotalMillis = 0;
    const remisionesProducto = [];
    if (this.remisionesPorProducto[producto.product_serie_ids[0]]) {
      this.remisionesPorProducto[producto.product_serie_ids[0]].forEach((remision) => {
        remision.startDateMillis = moment(remision.start_date).valueOf();
        remision.endDateMillis = moment(remision.end_date)
          .add(1)
          .valueOf();
        if (
          remision.startDateMillis >= this.millisFechaIni &&
            remision.startDateMillis <= this.millisFechaFin &&
            remision.endDateMillis >= this.millisFechaIni &&
            remision.endDateMillis <= this.millisFechaFin
        ) {
          remision.ocupacionEnTiempo =
              remision.endDateMillis - remision.startDateMillis;
          ocupacionTotalMillis += remision.ocupacionEnTiempo;
          remisionesProducto.push(remision);
        }
      });
    }
    return {
      ocupacionTotalMillis,
      documentos: this.remisionesPorProducto[producto.product_serie_ids[0]],
    };
  };
}
export  {ocupacionEnTiempo};
